module.exports = __webpack_public_path__ + "img/vk.641523a0.svg";